import env from '@/types/env'


export default function <K extends keyof typeof env> (key: K): typeof env[K] {
    return env[key]
}
